/**
 * Normaliza NEXT_PUBLIC_API_URL (baked no build do Next).
 * Sem protocolo (ex.: www.dominio.com.br) o browser trata como path relativo
 * → https://dominio.com.br/www.dominio.com.br/auth/login
 */
export function normalizeApiBaseUrl(raw: string | undefined): string {
  const fallback = 'http://localhost:3001/api/v1';
  const trimmed = raw?.trim();
  if (!trimmed) return fallback;

  let url = trimmed.replace(/\/+$/, '');
  if (!/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }
  if (!/\/api\/v1$/i.test(url)) {
    url = `${url}/api/v1`;
  }
  return url;
}

export const API_BASE_URL = normalizeApiBaseUrl(process.env.NEXT_PUBLIC_API_URL);
